import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as appDataActions from '../../../actions/appDataActions';
import Button from "../../buttons/Button";
import Resources from '../resourceLinks/ResourceLinks';
import BadgeCollect from '../badges/BadgeCollect';
import * as trackingDataActions from "../../../actions/trackingDataActions";
import * as userDataActions from "../../../actions/userDataActions";
import * as appHelper from "../../../helpers/appHelper";
import * as objectConstants from "../../../constants/objectConstants";
import * as animationHelper from "../../../helpers/animationHelper";

class ShortResponseFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgression: false,
            enableProgression: this.props.screenObject.kpis === null,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasBadges: appHelper.isDefined(this.props.screenObject.badges) && this.props.screenObject.badges.length > 0,
            badgesCollected: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            optionAsset: {
                src: ""
            },
            assetData: {},
            continue_label: appHelper.getLocaleString("continue_label")

        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);

        //Create Refs
        this.feedbackPanel = React.createRef();
    }

    componentDidMount() {
        //this.handleOptionFeedback();

        this.setResources();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    storeUserResponse() {
        let selectedOptions = [this.state.screenObject.asset_id];
        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: this.state.screenObject.kpis !== null ? this.state.screenObject.kpis : [],
            indicators: appHelper.isDefined(this.state.screenObject.indicators) && this.state.screenObject.indicators !== null ? this.state.screenObject.indicators : [],
        };
        this.props.callbacks.storeUserResponse(responseObj);
    }


    scrollToTop() {
        let feedbackPanel = this.feedbackPanel.current;
        if (appHelper.isDefined(feedbackPanel)) {
            this.props.scrollToFeedback(feedbackPanel.offsetTop);
        }
    }

    enableProgression() {
        this.setState({enableProgression: true});
    }

    onFeedbackRevealed() {
        //this.storeUserResponse();
        this.scrollToTop();
    }

    onFeedbackHidden() {
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }


    onProgressionClicked(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }
        //if(this.props.selfRate){
        let params = {
            userData: this.state.userData,
            bite_id: this.props.callbacks.getBiteId(),
            screen_id: this.props.callbacks.getScreenId(),
            parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
            asset_id: this.state.screenObject.asset_id,
            kpis: []
        };

        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((suspendData) => {
                this.hide();
            }).catch(error => {
            });
        }).catch(error => {
        });
        /*}else {
            this.hide();
        }*/
    }

    show() {
        let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackRevealed
        };
        animationHelper.showHeight(params);
    }

    hide() {
        let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackHidden
        };
        animationHelper.hideHeight(params);
    }


    onToolboxComplete(progression, asset_id, latestResponse) {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    render() {
        return (
            <div className="a-c" ref={this.feedbackPanel}>
                <div className={`feedback-panel reflective`}>
                    <div className="feedback-content-col">
                        {appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0
                            ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                            : null
                        }


                        {
                            this.state.hasResources
                                ?
                                <Resources resources={this.state.resourceLinks}
                                           onResourcesComplete={this.onResourcesComplete}/>
                                :
                                null
                        }

                        {/*this.props.selfRate && appHelper.isDefined(this.state.score_kpi.kpi_id)
                            ? <SelfRatingPanel bite_id={this.props.callbacks.getBiteId()} kpi={this.state.score_kpi}
                                               onComplete={this.onRatingSelected}/>
                            : null
                        */}


                        {
                            this.state.hasBadges
                                ?
                                <div>
                                    {this.state.screenObject.badges.map(badge =>
                                        <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                      bite_id={this.props.callbacks.getBiteId()}
                                                      asset_id={this.state.screenObject.asset_id}
                                                      onCollected={this.onBadgeCollected}/>
                                    )}
                                </div>
                                : null
                        }


                    </div>
                </div>
                { ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges ) && this.state.resourcesAreComplete
                    ?
                    <Button label={this.state.continue_label}
                            id={`${this.state.screenObject.asset_id}_button`}
                            onClick={this.onProgressionClicked}/>
                    : null
                }
            </div>
        );
    }
}

ShortResponseFeedback.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    onComplete: PropTypes.func,
    scrollToFeedback: PropTypes.func,
    selfRate: PropTypes.bool,
    saveRating: PropTypes.bool,
    actions: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    showImages: PropTypes.bool,

};

ShortResponseFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortResponseFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponseFeedback.js
 **/